import React, { Component } from 'react';
import { firebaseAuthentication } from '../../authentication'
import { Route, Redirect } from 'react-router-dom'

class ProtectedRoute extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogin : false
        }
    }
    async componentWillMount() {
        const isLogin = await firebaseAuthentication.authenticated
        this.setState({ isLogin })
        console.log("route props: ", this.props)
    }
    render() {
        
        const { component: Component, role, ...rest } = this.props

        return (
            <Route {...rest} render={(props) => {
                if (firebaseAuthentication.isAuthenticated == undefined) return <div></div>;
                else {
                    return firebaseAuthentication.isAuthenticated === true
                    ? <Component {...props} />
                    : <Redirect to='/pages/login-page' />
                }
                 
            }} />
        );
    }
}

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute/ProtectedRoute.jsx